// 个人书架接口
import { getPlatform } from '@/static/js/zjs'
import request from '../static/js/request'
import store from '@/store'
const appid = getPlatform().appid
const openid = store.state.user.openid

// 获取个人足迹
export function getHistoryList(num) {
  return request({
    url: `/mopa/api-answer-card/open/basicbook-weixinuser-collect/history/${appid}/${openid}`,
    method: 'GET',
    params: {
      num
    }
  })
}
// 获取书架列表（basicbook & holidaybook）用于个人书架全部展示
export function getCollectList() {
  return request({
    url: `/mopa/api-answer-card/open/book/wx/collect/list/${appid}/${openid}`,
    method: 'GET'
  })
}
// 非假期作业接口
// 获取书架列表（basicbook,非假期作业）用于查询收藏
export function getCollectBasicbookList() {
  return request({
    url: `/mopa/api-answer-card/open/basicbook-weixinuser-collect/list/${appid}/${openid}`,
    method: 'GET'
  })
}

// 加入书架（basicbook & holidaybook）
export function addCollect(data) {
  return request({
    url: `/mopa/api-answer-card/open/book/wx/collect/collect/${appid}/${openid}`,
    method: 'POST',
    data: data
  })
}

// 移出书架（basicbook & holidaybook）
export function deleteCollect(data) {
  return request({
    url: `/mopa/api-answer-card/open/book/wx/collect/remove/${appid}/${openid}`,
    method: 'POST',
    data: data
  })
}

// 清空书架（basicbook & holidaybook）
export function clearCollect() {
  return request({
    url: `/mopa/api-answer-card/open/book/wx/collect/remove-all/${appid}/${openid}`,
    method: 'POST'
  })
}
// 假期作业接口
// 获取书架列表（holidaybook,假期作业）用于查询收藏
export function getCollectHolidayBookList() {
  return request({
    url: `/mopa/api-answer-card/open/holidaybook/wx/collect/list/${appid}/${openid}`,
    method: 'GET'
  })
}
